<template>
  <div class="w-full h-full">
    <div class="flex justify-between mb-10px">
      <el-select
        v-model="search.state"
        class="w-49/100"
        placeholder="状态"
        @change="searchData"
        popper-class="visualization-select-popper"
        clearable
      >
        <el-option
          v-for="item in stateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="isModelRelation"
        class="w-49/100"
        placeholder="是否关联模型"
        @change="searchData"
        popper-class="visualization-select-popper"
        clearable
      >
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <el-input
      placeholder="请输入工作票号"
      v-model="search.ticketNo"
      size="small"
      clearable
      @keypress.enter.native="searchData()"
      class="icon-search__input mb-10px"
    >
      <i
        slot="append"
        class="el-icon-search cursor-pointer icon-search__input"
        @click="searchData()"
      ></i>
    </el-input>
    <div class="!h-[calc(100%-180px)] !w-full overflow-auto">
      <el-table
        :data="tableData"
        highlight-current-row
        height="100%"
        ref="tableRef"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" type="index" width="55"> </el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumns"
          :key="index"
          :label="item.label"
          :width="item.width"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div class="truncate" v-if="item.prop === 'ticketState'">
              {{ getState(scope.row.ticketState) }}
            </div>
            <div v-else-if="item.prop === 'deviceCodes' && scope.row.isModelRelation">
              <span class="text-blue-500"> {{ scope.row.deviceCodes }} </span>
            </div>
            <div v-else class="truncate">
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="60">
          <template slot-scope="{ row }">
            <el-button
              type="defult"
              size="mini"
              @click="lookDetail(row)"
              class="cursor-pointer !text-blue-500 !h-24px !leading-h-24px"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      small
      background
      @size-change="getTableData()"
      @current-change="getTableData()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="page.total"
      class="text-center"
    ></el-pagination>
    <operation-ticket-details
      v-if="operationDetailVis"
      @close="operationDetailVis = false"
      :title="title"
      :iframeUrl="iframeUrl"
      :id="operationDetailId"
    />
  </div>
</template>

<script>
import { workConfig } from './config'
import handoverService from '../../../service/HandoverService'
import { TicketApi } from '@wiz-api/dyw'

const { config } =
  Wiz.globalSettings.dynamicModules.modules['visualization-tongre-vulkan'].config.cockpitDyw || {}
// const metalbimapi = new MetalBIMApi()
const OperationTicketDetails = () => {
  return import('./OperationTicketDetails')
}
const smCryptoKey = config?.smCryptoKey
const userInfo = Wiz.AuthHooks.GetUserInfo()
const userAccount = userInfo.profile.preferred_username
const smCrypto = require('sm-crypto')
const ticketApi = new TicketApi()

export default {
  name: 'workTicketList',
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  components: { OperationTicketDetails },
  data() {
    return {
      iframeUrl: '', // 查看详情嵌入的地址
      id: '',
      title: '工作票',
      operationDetailVis: false,
      operationDetailId: '',
      tableData: [
        {
          id: 'weer2558wew',
          ticketState: 'WaitApprove',
          ticketNo: '20240508',
          deviceCodes: '010MBP38AT010',
          deviceNames: '汽轮机',
          workContent: '111111111111',
          isModelRelation: true,
        },
        {
          id: 'weer2558wew1',
          ticketState: 'WaitApprove',
          ticketNo: '20240508',
          deviceCodes: '610LDN62CM001',
          deviceNames: '汽轮机',
          workContent: '111111111111',
          isModelRelation: true,
        },
        {
          id: 'weer2558wew2',
          ticketState: 'WaitApprove',
          ticketNo: '20240508',
          deviceCodes: '通风塔外壳',
          deviceNames: '汽轮机',
          workContent: '111111111111',
          isModelRelation: true,
        },
        {
          id: 'weer2558wew3',
          ticketState: 'WaitApprove',
          ticketNo: '20240508',
          deviceCodes: '风扇轴',
          deviceNames: '汽轮机',
          workContent: '111111111111',
          isModelRelation: true,
        },
      ],
      tableLoading: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      isModelRelation: '',
      search: {
        state: '',
        ticketNo: '',
        deviceCodes: '',
      },
      stateList: [
        {
          label: '待提交',
          value: 'WaitCommit',
        },
        {
          label: '待审批',
          value: 'WaitApprove',
        },
        {
          label: '执行中',
          value: 'Executing',
        },
        {
          label: '已完成',
          value: 'Finished',
        },
        {
          label: '已作废',
          value: 'Cancel',
        },
        {
          label: '已归档',
          value: 'Archived',
        },
      ],
      statusList: [
        {
          label: '已关联模型',
          value: '1',
        },
        {
          label: '未关联模型',
          value: '2',
        },
      ],
      copyNodePtr: 0, // 暂存的节点
      copyMat: 0, // 暂存的材质
      defaultCameraInfo: null, // 默认视角参数
      clickInList: false,
    }
  },
  computed: {
    tableColumns() {
      return workConfig.pipelineSecondaryLedger.tableHead
    },
    searchApi() {
      return metalBimChildConfig.pipelineSecondaryLedger.api
    },
  },
  watch: {
    transferProps: {
      handler(data) {
        this.page.pageNo = 1
        this.getTableData()
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.defaultCameraInfo = await this.player.Native.Camera.currentParam() // 获取默认相机信息
    this.player.Native.ModelTree.EventSelectItemChanged.connect((e) => {
      if (!this.clickInList) {
        this.search.deviceCodes = e?.code
        this.searchData()
      }
      this.clickInList = false
    })
  },
  methods: {
    getState(state) {
      switch (state) {
        case 'WaitCommit':
          return '待提交'
        case 'WaitApprove':
          return '待审批'
        case 'Executing':
          return '执行中'
        case 'Finished':
          return '已完成'
        case 'Cancel':
          return '已作废'
        case 'Archived':
          return '已归档'
        default:
          return ''
      }
    },
    indexMethod(index) {
      if (index < 10) {
        return `0${index + 1}`
      }
      return index + 1
    },
    lookDetail(row) {
      const timeStamp = Date.now()
      const usernameStamp = `${userAccount}|${timeStamp}`
      const encryptStr = smCrypto.sm4.encrypt(usernameStamp, smCryptoKey)
      const workTicketDetailUrl = `/ticket/work-ticket/all-ticket/face?id=${row.id}`
      const encodedUrl = encodeURIComponent(workTicketDetailUrl)
      this.iframeUrl = `${config?.url}/#/authorize?encryptStr=${encryptStr}&r=${encodedUrl}`
      this.operationDetailVis = true
      this.operationDetailId = row.id
      this.title = `${row.deviceNames || ''}工作票`
      const deviceCodes = row.deviceCodes ? row.deviceCodes.split(',')[0] : ''
      this.findNodeByCode(deviceCodes, true)
    },
    // 恢复上一个node的颜色
    async resetColor() {
      if (this.copyNodePtr !== 0) {
        await this.player.Native.NodeProxy.setNodeMaterial(this.copyNodePtr, this.copyMat)
      }
    },
    // 恢复相机
    async resetCamera() {
      await this.player.Native.Camera.moveTo(
        this.defaultCameraInfo.eye,
        this.defaultCameraInfo.target,
        this.defaultCameraInfo.up,
        1
      )
    },
    // 通过设备code定位设备区域
    async findNodeByCode(code, clickInList) {
      this.clickInList = clickInList
      await this.resetColor()
      const codeInfo = await this.player.Native.ModelTree.getItemByCode(decodeURIComponent(code))
      if (codeInfo && codeInfo.nodePtr) {
        // 场景是以node的形式加载的
        await this.player.Native.Camera.moveToCode(decodeURIComponent(code), 1) // 相机跳转
        await this.player.Native.ModelTree.setSelectItem(codeInfo.item) // 模型选中
        this.copyNodePtr = codeInfo.nodePtr
        const mat = adeProxy.getNodeMaterial(codeInfo.nodePtr) // 材质的指针句柄
        this.copyMat = await this.player.Native.NodeProxy.copyMaterial(mat) // 复制材质,暂存材质
        await this.player.Native.NodeProxy.setMaterialDiffuse(mat, 1253923583)
      } else {
        await this.resetCamera()
      }
    },
    async getTableData() {
      this.tableLoading = true
      const [err, res] = await ticketApi.getWorkTickets(
        {
          body:{
            isModelRelation: this.isModelRelation ? this.isModelRelation : '0',
            unPage: false,
            pageNumber: this.page.pageNo,
            pageSize: this.page.pageSize,
            ...this.search,
          }
        }
      )
      if (!err && res && res.code === 0) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      } else {
        this.tableData = []
        this.page.total = 0
      }
      this.tableLoading = false
      // axios({
      //   method: 'GET',
      //   url: `${config?.url}${workConfig.pipelineSecondaryLedger.api}?unPage=false&pageNumber=${
      //     this.page.pageNo
      //   }&pageSize=${this.page.pageSize}&ticket=${this.ticketNo}&deviceCodes=${
      //     deviceCode || ''
      //   }`,
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'tenant-name': config?.tenantName,
      //     'org-id': config?.orgId,
      //     'token-id': config?.tokenId,
      //   },
      //   responseType: 'json',
      // })
      //   .then((res) => {
      //     this.tableData = res.data.data.items
      //     this.page.total = res.data.data.totalCount
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //   })
    },
    async searchData() {
      this.page.pageNo = 1
      await this.getTableData()
    },
  },
  async beforeDestroy() {
    await this.resetColor()
    this.copyNodePtr = 0
    this.copyMat = 0
    await this.resetCamera()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
::v-deep .el-pagination.is-background.el-pagination--small .el-pager li {
  min-width: 24px;
  margin: 0 5px;
  padding: 0 4px;
}
::v-deep {
  .el-table__body .el-table__row.hover-row > td.el-table__cell {
    background-color: transparent !important;
  }
}
</style>
